"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingContext = void 0;
const React = require("react");
exports.MarketingContext = React.createContext({
    retrieveMarketingItems: undefined,
    retrieveMarketingItemsError: undefined,
    isRetrievingMarketingItems: undefined
});
//# sourceMappingURL=index.js.map